<template>
	<div class="sanity-rich-text-component block--code-input my-100" v-html="code"></div>
</template>

<script setup lang="ts">
import { PortableTextComponentProps } from '@portabletext/vue';
import { SanityRichTextCodeInput } from 'types/sanity';

type Props = PortableTextComponentProps<SanityRichTextCodeInput>;

const props = defineProps<Props>();
const { code } = props.value.code;
</script>
